// extracted by mini-css-extract-plugin
export default {"container":"_k-z","bubbleNav":"al-z","graphic":"bl-z","contact":"cl-z"};